export default __webpack_public_path__ + "static/media/buy-bg-mobile.8c63df9f.png";